import { User } from "./User";

/**
 * Helper function that returns true if the id provided is any of the User's ids.
 *
 */
export function userHasAnyIdMatching(
  user: User,
  id: string,
  respectImpersonator?: boolean
) {
  if (user.ids.kazooId === id) {
    return true;
  }
  if (user.ids.rrId === id) {
    return true;
  }
  if (respectImpersonator) {
    return user.ids.yeiImpersonatingUserId === id;
  }

  return false;
}
